'use client';

import { Icon } from '@iconify/react';
import Link from 'next/link';

import { usePathname } from 'next/navigation';
import { useMemo } from 'react';
import { cn } from '../../../lib/utils';
import { getActiveTourismCategory, tourismNavItems } from './tourism-nav.config';

type TourismNavProps = {
  activeCategory?: (typeof tourismNavItems)[number]['value'];
};

export function TourismNav({ activeCategory: activeCategoryProp }: TourismNavProps) {
  const pathname = usePathname();
  const activeCategory = useMemo(
    () => activeCategoryProp ?? getActiveTourismCategory(pathname),
    [activeCategoryProp, pathname],
  );
  return (
    <nav aria-label="Категории туризма в Томске" className="sticky top-2 z-30 w-full">
      <div className="rounded-2xl border border-slate-700/50 bg-slate-900/70 p-2 shadow-lg backdrop-blur-md">
        <div className="flex flex-wrap gap-2">
          {tourismNavItems.map((item) => (
            <Link
              key={item.value}
              href={item.href}
              aria-current={activeCategory === item.value ? 'page' : undefined}
              className={cn(
                'flex shrink-0 items-center gap-2 rounded-xl border px-3 py-2 text-sm transition-colors md:text-base',
                activeCategory === item.value
                  ? 'border-sky-300/40 bg-sky-500/20 text-sky-200'
                  : 'border-slate-700/40 bg-slate-950/40 text-slate-300 hover:border-slate-500/60 hover:text-white',
              )}
            >
              <Icon
                icon={item.icon}
                style={{ color: item.color }}
                className="h-5 w-5"
                aria-hidden="true"
              />
              <span>{item.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}
